






































































































































import {State, Getter, Action, namespace} from 'vuex-class'
import {Vue, Prop, Component, Watch} from 'vue-property-decorator'
import _ from 'lodash'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import CustomMap from '@/components/CustomMap.vue'
import {IPatient} from '@/store/modules/views/patient/states'
import {UserProfile} from '@/store/modules/views/userProfile/states'
import {ELevel} from '@/services/Menus'


@Component({
  components: {CustomMap},
})
export default class CreatePatientDialog extends VueExtendedBaseComponent {
  @Prop({default: ''}) private status!: string
  @Prop() private open!: boolean
  @Prop() private callback!: (data: IPatient) => void
  @Prop() private getList!: () => Promise<void>
  @Getter('userprofile/getProfile')
  private profile!: UserProfile
  private center = ''
  private search = ''
  private prefix = ''

  private options = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
  }

  get formInstant(): Vue & {
    validate: () => any
    resetValidation: () => any
    reset: () => any,
  } {
    return this.$refs.form as Vue & {
      validate: () => any
      resetValidation: () => any
      reset: () => any,
    }
  }

  get centerLists() {
    return this.centerItemLists
  }

  @Getter('components/prefixNames')
  private prefixNames: string[]

  @Getter('center/centerLists')
  private centerItemLists!: () => void

  @Action('components/sendMsgInLine')
  private sendMsgInLine: (messages: any) => Promise<void>

  @Action('patient/getPatientTypeList')
  private getPatientTypeList!: (headerParams: {
    headers: {
      page: number
      limit: number
      sortBy: string
      sortDesc: boolean
      search: string
      filter: string,
    },
  }) => void

  @Action('patient/postPatient')
  private postPatient!: (options: {}) => Promise<IPatient>

  @Action('center/getCenterList')
  private getCentertList!: (headerParams: {
    headers: {
      page: number
      limit: number
      sortBy: string
      sortDesc: boolean
      search: string
      filter: string,
    },
  }) => void

  @Action('user/getUserListByLevel')
  private getUserList!: () => void

  @Getter('patient/patientTypeLists')
  private patientTypeItemLists!: () => void

  @Getter('user/userLists')
  private userItemLists!: () => void

  get userLists() {
    return this.userItemLists
  }

  private activePicker = null
  private valid = false
  private firstname = ''
  private lastname = ''
  private phoneNumber = ''
  private cid = ''
  private sosPhoneNumber = ''
  private disease = ''
  private drugAllergy = ''
  private hospital = ''
  private date = null
  private menu = false
  private loading = false
  private snackbar = false
  private useritems = ''
  private userId = ''
  private address = ''
  // private patientTypeitems = ''
  private map = {
    lat: 0,
    lon: 0,
  }
  private optionUser = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
  }
  private location: IPatient['address'] = {address: ''}

  public async created() {
    await Promise.all([
      this.getPatientTypeListFunc(),
      this.getCenterListFunc(),
      this.getUserFunc(),
    ])
  }

  private autoSelf() {
    this.firstname = this.profile.firstname
    this.lastname = this.profile.lastname
    this.phoneNumber = this.profile.phone
    this.cid = this.profile.idCard
    this.date = this.profile.birthdate
    this.prefix = this.profile.prefix
    this.address = this.profile.address.address
    this.location = this.profile.address
    this.map = this.profile.map
  }

  private requireInput(value) {
    return value !== '' || 'จำเป็นต้องกรอก'
  }

  get age() {
    const age = this.diffDate(this.date)
    const year = Math.floor(age)
    const month = Math.floor((age - year) * 12)
    return `อายุ ${year ? year + 'ปี ' : ''}${month}เดือน`
  }

  get invalidateInput() {
    return _.some(
        [
          this.validateInputFromType('phone', this.phoneNumber, true),
          this.validateInputFromType('phone', this.sosPhoneNumber, true),
          this.validateInputFromType('text', this.address, true),
          this.validateInputFromType('number', this.map.lat.toString()),
          this.validateInputFromType('number', this.map.lon.toString()),
          this.validateInputFromType('cid', this.cid),
        ],
        (item) => item !== true,
    )
  }

  private changeDateType() {
    this.menu = false
  }

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get createPatientDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'เพิ่ม',
          action: this.createPatientAction,
          loading: this.loading,
          height: '30',
          color: 'primary',
        },
      },
    }
  }

  private async getPatientTypeListFunc() {
    await this.getPatientTypeList({
      headers: {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sortBy: 'score',
        sortDesc: true,
        search: Buffer.from(this.options.search).toString('base64'),
        filter: Buffer.from(JSON.stringify({})).toString('base64'),
      },
    })
  }

  private requireSelect(value) {
    return [(v) => !!v || 'จำเป็นต้องเลือก']
  }

  get validateInput() {
    return this.nameValidate(this.firstname) && this.nameValidate(this.lastname)
  }

  private async createPatientAction() {
    const validate = this.formInstant.validate()
    if (!(this.map.lat && this.map.lon)) {
      this.updateSnackbar({txt: 'กรุณากดที่อยู่ในแผนที่', type: 'error'})
      return false
    }
    if (validate) {
      this.loading = true
      try {
        const res = await this.postPatient({
          userId: this.level.mode === ELevel.USER ? this.profile._id : this.userId,
          centerId: this.center,
          // patientTypeId: this.patientTypeitems,
          prefix: this.prefix,
          firstname: this.firstname,
          lastname: this.lastname,
          phone: this.phoneNumber,
          idCard: this.cid,
          address: {address: this.address, ...this.location},
          map: this.map,
          sosPhone: this.sosPhoneNumber,
          birthdate: this.date,
          drugAllergy: this.drugAllergy,
          disease: this.disease,
          hospital: this.hospital,
          status: 'ยังไม่ทำแบบประเมิน',
        })
        this.updateSnackbar({txt: 'เพิ่มผู้สูงอายุ/ผู้ป่วยสำเร็จ', type: 'success'})
        await this.sendMsgInLine([{
          type: 'text',
          text: 'เพิ่มผู้สูงอายุ/ผู้ป่วยสำเร็จ',
        }])
        await this.callback(res)
        this.loading = false
        // this.closeDialog()
      } catch (e) {
        this.loading = false
        return false
      }
    } else {
      return false
    }
  }

  private async getCenterListFunc() {
    await this.getCentertList({
      headers: {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sortBy: _.get(this.options, 'sortBy[0]', 'createdAt'),
        sortDesc: _.get(this.options, 'sortDesc[0]', true),
        search: Buffer.from(this.options.search).toString('base64'),
        filter: Buffer.from(JSON.stringify({})).toString('base64'),
      },
    })
  }

  private async getUserFunc() {
    if (this.level.mode !== ELevel.USER) {
      await this.getUserList()
    }
  }

  private async changeUser() {
    if (this.useritems != null) {
      this.userId = this.useritems[`_id`]
    }
    this.menu = false
  }

  @Watch('menu')
  private birthdate(val) {
    if (val) {
      setTimeout(() => (this.activePicker = 'YEAR'))
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
